import { SeamlessConnection } from '@seamless/store';
import type { TrackingEvent, TrackingReducerState, OwcTrackingDispatchers } from './types';
import { isBrowser } from './utils';

// the reducer connection name please use getTrackingReducerConnection() if you need the connection
export const connectionName = 'OWC_TRACKING_MANAGER';

// Action const
export const PUSH_TRACKING_EVENT = 'PUSH_TRACKING_EVENT';

const initialTrackingState: TrackingReducerState = {
  trackingEvents: [],
};

class TrackingConnection extends SeamlessConnection<OwcTrackingDispatchers, TrackingReducerState> {
  constructor() {
    super(connectionName);
  }

  get initialState() {
    return initialTrackingState;
  }

  getReducer() {
    return (state = initialTrackingState, action: any) => {
      if (action.type === this.getActionType(PUSH_TRACKING_EVENT)) {
        return {
          ...state,
          trackingEvents: [...state.trackingEvents, action.payload],
        };
      }

      return state;
    };
  }

  getPublicDispatchers(): OwcTrackingDispatchers {
    return {
      pushTrackingEvent: (trackingEvent: TrackingEvent) => {
        if (isBrowser()) {
          window.top?.dataLayer_ow.push(trackingEvent);
        }

        return this.getAction(PUSH_TRACKING_EVENT, trackingEvent);
      },
    };
  }
}

export const connection = new TrackingConnection();
